// src/pages/Admin/Settings/components/SettingsSidebar.jsx
import React from "react";

function cn(...c) {
  return c.filter(Boolean).join(" ");
}

export default function SettingsSidebar({
  brandTitle,
  brandSubtitle,
  icon: BrandIcon,
  items = [],
  activeKey,
  onChange,
}) {
  return (
    <aside className="hidden lg:flex flex-col border-r border-slate-200/70 dark:border-slate-800">
      <div className="p-5">
        <div className="rounded-3xl bg-gradient-to-br from-slate-900 to-slate-700 dark:from-white dark:to-slate-200 text-white dark:text-slate-900 p-5 shadow-sm">
          <div className="flex items-start gap-3">
            <div className="h-11 w-11 rounded-2xl bg-white/15 dark:bg-slate-900/10 grid place-items-center">
              {BrandIcon ? <BrandIcon className="h-5 w-5" /> : null}
            </div>
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-widest opacity-90">
                {brandTitle}
              </div>
              <div className="mt-1 text-lg font-extrabold leading-tight">
                {brandSubtitle}
              </div>
              <div className="mt-2 text-xs/5 opacity-85">
                Navigation & configuration
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="px-3 pb-6">
        <div className="px-2 pb-2 text-xs font-semibold uppercase tracking-widest text-slate-500 dark:text-slate-400">
          Sections
        </div>

        <div className="space-y-1">
          {items.map((it) => {
            const Icon = it.icon;
            const isActive = activeKey === it.key;

            return (
              <button
                key={it.key}
                onClick={() => onChange?.(it.key)}
                className={cn(
                  "w-full group flex items-center gap-3 rounded-2xl px-3 py-2.5 text-left transition ring-1",
                  isActive
                    ? "bg-slate-900 text-white ring-slate-900 shadow-sm dark:bg-white dark:text-slate-900 dark:ring-white"
                    : "bg-white/60 dark:bg-slate-900/40 text-slate-700 dark:text-slate-200 ring-slate-200/70 dark:ring-slate-800 hover:bg-white dark:hover:bg-slate-900"
                )}
              >
                <span
                  className={cn(
                    "h-10 w-10 rounded-2xl grid place-items-center transition",
                    isActive
                      ? "bg-white/15 dark:bg-slate-900/10"
                      : "bg-slate-100 dark:bg-slate-800/60 group-hover:bg-slate-200 dark:group-hover:bg-slate-800"
                  )}
                >
                  <Icon className="h-5 w-5" />
                </span>

                <span className="min-w-0">
                  <span className="block font-semibold truncate">
                    {it.label}
                  </span>
                  <span
                    className={cn(
                      "block text-xs truncate",
                      isActive
                        ? "text-white/80 dark:text-slate-700"
                        : "text-slate-500 dark:text-slate-400"
                    )}
                  >
                    Ouvrir
                  </span>
                </span>

                <span
                  className={cn(
                    "ml-auto h-2 w-2 rounded-full transition",
                    isActive
                      ? "bg-emerald-300 dark:bg-emerald-500"
                      : "bg-slate-300 dark:bg-slate-700 group-hover:bg-slate-400 dark:group-hover:bg-slate-600"
                  )}
                />
              </button>
            );
          })}
        </div>
      </nav>
    </aside>
  );
}